import React, { useState, useRef } from 'react';
import { useStore } from '../context/ProductStore';

const TECHDAVE_INFO = {
  name:    'Techdave Solutions',
  address: 'B30 Eastgate Market, Harare, Zimbabwe',
  phone1:  '+263 772 758 875',
  phone2:  '+263 785 661 758',
  email:   'sales@techdavesolutions.co.zw',
  website: 'www.techdavesolutions.co.zw',
  logo:    '/techdave-logo.png',
};

const QuotationModal = ({ onClose, initialCustomer }) => {
  const { products } = useStore();
  const [step, setStep] = useState(1); // 1=customer info, 2=select products, 3=preview
  const [customer, setCustomer] = useState({
    name: initialCustomer?.name || '',
    company: '',
    email: initialCustomer?.email || '',
    phone: initialCustomer?.phone || '',
    address: '',
  });
  const [quoteItems, setQuoteItems] = useState([]);
  const [search, setSearch] = useState('');
  const [notes, setNotes] = useState('');
  const [validDays, setValidDays] = useState(7);
  const [quoteNum] = useState(`TD-Q${Date.now().toString().slice(-6)}`);
  const today = new Date().toLocaleDateString('en-GB', { day:'2-digit', month:'long', year:'numeric' });
  const expiry = new Date(Date.now() + validDays * 86400000).toLocaleDateString('en-GB', { day:'2-digit', month:'long', year:'numeric' });
  const printRef = useRef();

  const inStock = products.filter(p => !p.outOfStock);
  const filtered = inStock.filter(p =>
    p.name?.toLowerCase().includes(search.toLowerCase()) ||
    p.category?.toLowerCase().includes(search.toLowerCase()) ||
    p.brand?.toLowerCase().includes(search.toLowerCase())
  );

  const addItem = (product) => {
    setQuoteItems(prev => {
      const exists = prev.find(i => i.id === product.id);
      if (exists) return prev.map(i => i.id === product.id ? { ...i, qty: i.qty + 1 } : i);
      const price = product.isPromo && product.promoPrice ? parseFloat(product.promoPrice) : parseFloat(product.price);
      return [...prev, { id: product.id, name: product.name, brand: product.brand, category: product.category, unitPrice: price, qty: 1 }];
    });
  };

  const removeItem = (id) => setQuoteItems(prev => prev.filter(i => i.id !== id));
  const updateQty  = (id, qty) => {
    if (qty < 1) return removeItem(id);
    setQuoteItems(prev => prev.map(i => i.id === id ? { ...i, qty } : i));
  };
  const updatePrice = (id, price) => setQuoteItems(prev => prev.map(i => i.id === id ? { ...i, unitPrice: parseFloat(price)||0 } : i));

  const subtotal = quoteItems.reduce((sum, i) => sum + i.unitPrice * i.qty, 0);
  const tax      = 0; // add VAT if needed
  const total    = subtotal + tax;

  const handlePrint = () => {
    const printContent = printRef.current.innerHTML;
    const win = window.open('', '_blank');
    win.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
        <title>Quotation ${quoteNum} - Techdave Solutions</title>
        <style>
          * { margin:0; padding:0; box-sizing:border-box; }
          body { font-family: Arial, sans-serif; font-size: 13px; color: #111; background: #fff; }
          .quote-wrap { max-width: 800px; margin: 0 auto; padding: 32px; }
          .header { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 32px; border-bottom: 3px solid #CC0000; padding-bottom: 20px; }
          .company-name { font-size: 22px; font-weight: 900; color: #CC0000; letter-spacing: 1px; }
          .company-info { font-size: 11px; color: #555; line-height: 1.7; margin-top: 4px; }
          .quote-title { font-size: 28px; font-weight: 900; color: #111; text-align: right; }
          .quote-meta { text-align: right; font-size: 12px; color: #555; margin-top: 6px; line-height: 1.7; }
          .quote-num { color: #CC0000; font-weight: 700; }
          .parties { display: grid; grid-template-columns: 1fr 1fr; gap: 24px; margin-bottom: 28px; }
          .party-box { background: #f9f9f9; border-left: 3px solid #CC0000; padding: 14px 16px; }
          .party-label { font-size: 10px; font-weight: 800; color: #CC0000; letter-spacing: 0.1em; text-transform: uppercase; margin-bottom: 8px; }
          .party-name { font-size: 15px; font-weight: 700; color: #111; }
          .party-detail { font-size: 12px; color: #555; line-height: 1.7; margin-top: 4px; }
          table { width: 100%; border-collapse: collapse; margin-bottom: 20px; }
          th { background: #CC0000; color: #fff; padding: 10px 12px; text-align: left; font-size: 12px; font-weight: 700; letter-spacing: 0.04em; text-transform: uppercase; }
          th:last-child, td:last-child { text-align: right; }
          th:nth-child(3), td:nth-child(3), th:nth-child(4), td:nth-child(4) { text-align: center; }
          td { padding: 10px 12px; border-bottom: 1px solid #e5e7eb; font-size: 13px; }
          tr:nth-child(even) td { background: #fafafa; }
          .item-name { font-weight: 600; }
          .item-brand { font-size: 11px; color: #888; margin-top: 2px; }
          .totals { margin-left: auto; width: 260px; }
          .total-row { display: flex; justify-content: space-between; padding: 6px 0; font-size: 13px; border-bottom: 1px solid #f0f0f0; }
          .total-row.grand { border-top: 2px solid #CC0000; border-bottom: none; padding-top: 10px; margin-top: 4px; font-size: 16px; font-weight: 900; color: #CC0000; }
          .validity { background: #fff8f8; border: 1px solid rgba(204,0,0,0.2); border-radius: 6px; padding: 12px 16px; margin-bottom: 20px; font-size: 12px; color: #555; }
          .validity strong { color: #CC0000; }
          .notes-box { background: #f9f9f9; border-radius: 6px; padding: 12px 16px; margin-bottom: 24px; font-size: 12px; color: #555; line-height: 1.7; }
          .notes-label { font-weight: 700; color: #111; margin-bottom: 4px; }
          .footer { border-top: 2px solid #CC0000; padding-top: 16px; display: flex; justify-content: space-between; align-items: center; }
          .footer-thanks { font-size: 13px; font-weight: 700; color: #CC0000; }
          .footer-contact { font-size: 11px; color: #555; text-align: right; line-height: 1.7; }
          .sign-section { display: grid; grid-template-columns: 1fr 1fr; gap: 40px; margin: 32px 0 24px; }
          .sign-box { border-top: 1px solid #333; padding-top: 8px; font-size: 11px; color: #555; }
          @media print { body { -webkit-print-color-adjust: exact; print-color-adjust: exact; } }
        </style>
      </head>
      <body>${printContent}</body>
      </html>
    `);
    win.document.close();
    win.focus();
    setTimeout(() => { win.print(); win.close(); }, 400);
  };

  const handleWhatsApp = () => {
    let msg = `*QUOTATION ${quoteNum}*\n`;
    msg += `📅 Date: ${today}\n`;
    msg += `⏳ Valid until: ${expiry}\n\n`;
    msg += `*Customer:* ${customer.name}${customer.company ? ` (${customer.company})` : ''}\n\n`;
    msg += `*ITEMS:*\n`;
    quoteItems.forEach((item, i) => {
      msg += `${i+1}. ${item.name}\n`;
      msg += `   Qty: ${item.qty} × USD ${item.unitPrice.toFixed(2)} = USD ${(item.qty * item.unitPrice).toFixed(2)}\n`;
    });
    msg += `\n*TOTAL: USD ${total.toFixed(2)}*\n`;
    if (notes) msg += `\n📝 Notes: ${notes}\n`;
    msg += `\n_Techdave Solutions | ${TECHDAVE_INFO.phone1} | ${TECHDAVE_INFO.website}_`;
    window.open(`https://wa.me/263772758875?text=${encodeURIComponent(msg)}`, '_blank');
  };

  return (
    <>
      <style>{`
        .qm-input:focus { border-color: #CC0000 !important; outline: none; }
        .qm-prod-row:hover { background: #f0f4ff !important; }
        .qm-step-btn { transition: all 0.15s; }
        .qm-step-btn:hover { opacity: 0.85; }
        @media print { .no-print { display: none !important; } }
      `}</style>

      <div style={{ position:'fixed', inset:0, zIndex:99999, backgroundColor:'rgba(0,0,0,0.7)', backdropFilter:'blur(4px)', display:'flex', alignItems:'center', justifyContent:'center', padding:16 }}>
        <div style={{ backgroundColor:'#fff', borderRadius:16, width:'100%', maxWidth:820, maxHeight:'92vh', display:'flex', flexDirection:'column', overflow:'hidden', boxShadow:'0 24px 80px rgba(0,0,0,0.3)' }}>

          {/* Header */}
          <div style={{ background:'linear-gradient(135deg,#CC0000,#990000)', padding:'18px 24px', display:'flex', justifyContent:'space-between', alignItems:'center', flexShrink:0 }}>
            <div>
              <div style={{ fontSize:18, fontWeight:800, color:'#fff', fontFamily:"'League Spartan', sans-serif" }}>📄 Generate Quotation</div>
              <div style={{ fontSize:12, color:'rgba(255,255,255,0.75)', marginTop:2 }}>{quoteNum} · {today}</div>
            </div>
            <button onClick={onClose} style={{ background:'rgba(255,255,255,0.15)', border:'none', color:'#fff', width:34, height:34, borderRadius:'50%', cursor:'pointer', fontSize:18, display:'flex', alignItems:'center', justifyContent:'center' }}>✕</button>
          </div>

          {/* Steps indicator */}
          <div style={{ display:'flex', borderBottom:'1px solid #e5e7eb', flexShrink:0 }}>
            {[['1','Customer Info'],['2','Select Products'],['3','Preview & Send']].map(([num, label]) => (
              <button key={num} onClick={() => parseInt(num) < step || quoteItems.length > 0 ? setStep(parseInt(num)) : null}
                style={{ flex:1, padding:'12px 8px', border:'none', background: step===parseInt(num)?'#fff':'#f9fafb', borderBottom: step===parseInt(num)?'2px solid #CC0000':'2px solid transparent', cursor:'pointer', fontFamily:"'Inter', sans-serif", fontSize:13, fontWeight: step===parseInt(num)?700:500, color: step===parseInt(num)?'#CC0000':'#6b7280', display:'flex', alignItems:'center', justifyContent:'center', gap:6 }}>
                <span style={{ width:22, height:22, borderRadius:'50%', background: step===parseInt(num)?'#CC0000':'#e5e7eb', color: step===parseInt(num)?'#fff':'#555', fontSize:11, fontWeight:800, display:'flex', alignItems:'center', justifyContent:'center' }}>{num}</span>
                {label}
              </button>
            ))}
          </div>

          {/* Content */}
          <div style={{ flex:1, overflowY:'auto', padding:24 }}>

            {/* STEP 1 — Customer Info */}
            {step === 1 && (
              <div style={{ display:'flex', flexDirection:'column', gap:16 }}>
                <p style={{ fontSize:13, color:'#6b7280', margin:0 }}>Enter the customer's details for the quotation header.</p>
                <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }}>
                  {[
                    { label:'Full Name *', key:'name', placeholder:'e.g. John Moyo', type:'text' },
                    { label:'Company / Organisation', key:'company', placeholder:'e.g. ABC Enterprises (optional)', type:'text' },
                    { label:'Email Address', key:'email', placeholder:'customer@email.com', type:'email' },
                    { label:'Phone Number', key:'phone', placeholder:'+263 7XX XXX XXX', type:'tel' },
                  ].map(f => (
                    <div key={f.key} style={{ display:'flex', flexDirection:'column', gap:5 }}>
                      <label style={{ fontSize:12, fontWeight:700, color:'#374151' }}>{f.label}</label>
                      <input className="qm-input" type={f.type} placeholder={f.placeholder}
                        value={customer[f.key]} onChange={e => setCustomer(prev => ({ ...prev, [f.key]: e.target.value }))}
                        style={{ padding:'9px 12px', border:'1.5px solid #e5e7eb', borderRadius:8, fontSize:13, fontFamily:"'Inter', sans-serif", color:'#111' }} />
                    </div>
                  ))}
                  <div style={{ display:'flex', flexDirection:'column', gap:5, gridColumn:'span 2' }}>
                    <label style={{ fontSize:12, fontWeight:700, color:'#374151' }}>Delivery / Billing Address</label>
                    <input className="qm-input" placeholder="Physical address (optional)"
                      value={customer.address} onChange={e => setCustomer(prev => ({ ...prev, address: e.target.value }))}
                      style={{ padding:'9px 12px', border:'1.5px solid #e5e7eb', borderRadius:8, fontSize:13, fontFamily:"'Inter', sans-serif", color:'#111' }} />
                  </div>
                </div>
                <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }}>
                  <div style={{ display:'flex', flexDirection:'column', gap:5 }}>
                    <label style={{ fontSize:12, fontWeight:700, color:'#374151' }}>Quotation Valid For</label>
                    <select className="qm-input" value={validDays} onChange={e => setValidDays(parseInt(e.target.value))}
                      style={{ padding:'9px 12px', border:'1.5px solid #e5e7eb', borderRadius:8, fontSize:13, fontFamily:"'Inter', sans-serif", color:'#111' }}>
                      {[3,7,14,30].map(d => <option key={d} value={d}>{d} days (expires {new Date(Date.now()+d*86400000).toLocaleDateString('en-GB')})</option>)}
                    </select>
                  </div>
                </div>
                <button onClick={() => setStep(2)} disabled={!customer.name.trim()}
                  style={{ padding:'12px 24px', borderRadius:8, border:'none', background: customer.name.trim()?'#CC0000':'#e5e7eb', color: customer.name.trim()?'#fff':'#999', fontWeight:700, fontSize:14, cursor: customer.name.trim()?'pointer':'not-allowed', alignSelf:'flex-end' }}>
                  Next: Select Products →
                </button>
              </div>
            )}

            {/* STEP 2 — Select Products */}
            {step === 2 && (
              <div style={{ display:'flex', flexDirection:'column', gap:14 }}>
                {/* Search */}
                <input className="qm-input" placeholder="🔍 Search products by name, brand or category..."
                  value={search} onChange={e => setSearch(e.target.value)}
                  style={{ padding:'10px 14px', border:'1.5px solid #e5e7eb', borderRadius:8, fontSize:13, fontFamily:"'Inter', sans-serif" }} />

                {/* Product list */}
                <div style={{ border:'1px solid #e5e7eb', borderRadius:8, overflow:'hidden', maxHeight:280, overflowY:'auto' }}>
                  {filtered.length === 0 && <div style={{ padding:24, textAlign:'center', color:'#9ca3af', fontSize:13 }}>No products found</div>}
                  {filtered.map(p => {
                    const price = p.isPromo && p.promoPrice ? parseFloat(p.promoPrice) : parseFloat(p.price);
                    const inQuote = quoteItems.find(i => i.id === p.id);
                    return (
                      <div key={p.id} className="qm-prod-row"
                        style={{ display:'flex', alignItems:'center', gap:12, padding:'10px 14px', borderBottom:'1px solid #f3f4f6', cursor:'pointer', background: inQuote?'#fef3f2':'#fff' }}
                        onClick={() => addItem(p)}>
                        <div style={{ width:40, height:40, borderRadius:6, backgroundColor:'#f9fafb', border:'1px solid #e5e7eb', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0, overflow:'hidden' }}>
                          {(p.images?.[0]||p.image) ? <img src={p.images?.[0]||p.image} alt={p.name} style={{ width:'100%', height:'100%', objectFit:'contain' }} /> : <span>📦</span>}
                        </div>
                        <div style={{ flex:1, minWidth:0 }}>
                          <div style={{ fontSize:13, fontWeight:600, color:'#111', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{p.name}</div>
                          <div style={{ fontSize:11, color:'#6b7280' }}>{p.brand} · {p.category}</div>
                        </div>
                        <div style={{ fontSize:13, fontWeight:700, color:'#CC0000', flexShrink:0 }}>USD {price.toFixed(2)}</div>
                        <div style={{ width:28, height:28, borderRadius:'50%', background: inQuote?'#CC0000':'#e5e7eb', color: inQuote?'#fff':'#555', display:'flex', alignItems:'center', justifyContent:'center', fontSize:18, fontWeight:700, flexShrink:0 }}>
                          {inQuote ? '✓' : '+'}
                        </div>
                      </div>
                    );
                  })}
                </div>

                {/* Selected items */}
                {quoteItems.length > 0 && (
                  <div style={{ border:'1px solid #e5e7eb', borderRadius:8, overflow:'hidden' }}>
                    <div style={{ background:'#f9fafb', padding:'8px 14px', fontSize:11, fontWeight:800, color:'#374151', letterSpacing:'0.06em', textTransform:'uppercase', borderBottom:'1px solid #e5e7eb' }}>
                      Selected Items ({quoteItems.length})
                    </div>
                    {quoteItems.map(item => (
                      <div key={item.id} style={{ display:'flex', alignItems:'center', gap:10, padding:'10px 14px', borderBottom:'1px solid #f3f4f6' }}>
                        <div style={{ flex:1, minWidth:0 }}>
                          <div style={{ fontSize:13, fontWeight:600, color:'#111', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{item.name}</div>
                          <div style={{ fontSize:11, color:'#6b7280' }}>{item.brand}</div>
                        </div>
                        {/* Unit price editable */}
                        <div style={{ display:'flex', alignItems:'center', gap:4, flexShrink:0 }}>
                          <span style={{ fontSize:11, color:'#6b7280' }}>USD</span>
                          <input type="number" value={item.unitPrice} onChange={e => updatePrice(item.id, e.target.value)}
                            style={{ width:70, padding:'4px 6px', border:'1px solid #e5e7eb', borderRadius:6, fontSize:12, fontWeight:600, textAlign:'right', fontFamily:"'Inter', sans-serif" }} />
                        </div>
                        {/* Qty */}
                        <div style={{ display:'flex', alignItems:'center', gap:4, flexShrink:0 }}>
                          <button onClick={() => updateQty(item.id, item.qty-1)} style={{ width:24, height:24, borderRadius:4, border:'1px solid #e5e7eb', background:'#f9fafb', cursor:'pointer', fontSize:14, fontWeight:700, display:'flex', alignItems:'center', justifyContent:'center' }}>−</button>
                          <span style={{ fontSize:13, fontWeight:700, minWidth:20, textAlign:'center' }}>{item.qty}</span>
                          <button onClick={() => updateQty(item.id, item.qty+1)} style={{ width:24, height:24, borderRadius:4, border:'1px solid #e5e7eb', background:'#f9fafb', cursor:'pointer', fontSize:14, fontWeight:700, display:'flex', alignItems:'center', justifyContent:'center' }}>+</button>
                        </div>
                        <div style={{ fontSize:13, fontWeight:700, color:'#111', minWidth:80, textAlign:'right', flexShrink:0 }}>USD {(item.unitPrice*item.qty).toFixed(2)}</div>
                        <button onClick={() => removeItem(item.id)} style={{ background:'none', border:'none', color:'#f87171', cursor:'pointer', fontSize:16, padding:0, flexShrink:0 }}>✕</button>
                      </div>
                    ))}
                    <div style={{ padding:'10px 14px', display:'flex', justifyContent:'flex-end', borderTop:'2px solid #CC0000' }}>
                      <span style={{ fontSize:16, fontWeight:900, color:'#CC0000' }}>Total: USD {total.toFixed(2)}</span>
                    </div>
                  </div>
                )}

                {/* Notes */}
                <div style={{ display:'flex', flexDirection:'column', gap:5 }}>
                  <label style={{ fontSize:12, fontWeight:700, color:'#374151' }}>Notes / Terms (optional)</label>
                  <textarea className="qm-input" placeholder="e.g. Prices inclusive of delivery. Payment terms: 50% deposit..."
                    value={notes} onChange={e => setNotes(e.target.value)} rows={3}
                    style={{ padding:'9px 12px', border:'1.5px solid #e5e7eb', borderRadius:8, fontSize:13, fontFamily:"'Inter', sans-serif", resize:'vertical' }} />
                </div>

                <div style={{ display:'flex', gap:10, justifyContent:'flex-end' }}>
                  <button onClick={() => setStep(1)} style={{ padding:'10px 20px', borderRadius:8, border:'1px solid #e5e7eb', background:'#fff', color:'#555', fontWeight:600, fontSize:13, cursor:'pointer' }}>← Back</button>
                  <button onClick={() => setStep(3)} disabled={quoteItems.length===0}
                    style={{ padding:'10px 24px', borderRadius:8, border:'none', background: quoteItems.length>0?'#CC0000':'#e5e7eb', color: quoteItems.length>0?'#fff':'#999', fontWeight:700, fontSize:13, cursor: quoteItems.length>0?'pointer':'not-allowed' }}>
                    Preview Quote →
                  </button>
                </div>
              </div>
            )}

            {/* STEP 3 — Preview */}
            {step === 3 && (
              <div style={{ display:'flex', flexDirection:'column', gap:16 }}>
                {/* Action buttons */}
                <div className="no-print" style={{ display:'flex', gap:10, flexWrap:'wrap' }}>
                  <button onClick={handlePrint}
                    style={{ padding:'10px 20px', borderRadius:8, border:'none', background:'#111', color:'#fff', fontWeight:700, fontSize:13, cursor:'pointer', display:'flex', alignItems:'center', gap:6 }}>
                    🖨️ Print / Save PDF
                  </button>
                  <button onClick={handleWhatsApp}
                    style={{ padding:'10px 20px', borderRadius:8, border:'none', background:'#25D366', color:'#fff', fontWeight:700, fontSize:13, cursor:'pointer', display:'flex', alignItems:'center', gap:6 }}>
                    💬 Send via WhatsApp
                  </button>
                  <button onClick={() => setStep(2)}
                    style={{ padding:'10px 20px', borderRadius:8, border:'1px solid #e5e7eb', background:'#fff', color:'#555', fontWeight:600, fontSize:13, cursor:'pointer' }}>
                    ← Edit Items
                  </button>
                </div>

                {/* Quote preview */}
                <div ref={printRef} style={{ border:'1px solid #e5e7eb', borderRadius:8, overflow:'hidden' }}>
                  <div className="quote-wrap" style={{ padding:32, fontFamily:'Arial, sans-serif', fontSize:13, color:'#111', background:'#fff' }}>

                    {/* Header */}
                    <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:28, borderBottom:'3px solid #CC0000', paddingBottom:18 }}>
                      <div>
                        <div style={{ fontSize:22, fontWeight:900, color:'#CC0000', letterSpacing:1 }}>TECHDAVE SOLUTIONS</div>
                        <div style={{ fontSize:11, color:'#555', lineHeight:1.8, marginTop:4 }}>
                          {TECHDAVE_INFO.address}<br/>
                          📞 {TECHDAVE_INFO.phone1} | {TECHDAVE_INFO.phone2}<br/>
                          ✉️ {TECHDAVE_INFO.email}<br/>
                          🌐 {TECHDAVE_INFO.website}
                        </div>
                      </div>
                      <div style={{ textAlign:'right' }}>
                        <div style={{ fontSize:28, fontWeight:900, color:'#111' }}>QUOTATION</div>
                        <div style={{ fontSize:12, color:'#555', marginTop:6, lineHeight:1.8 }}>
                          <span style={{ color:'#CC0000', fontWeight:700 }}>{quoteNum}</span><br/>
                          Date: {today}<br/>
                          Valid until: <strong>{expiry}</strong>
                        </div>
                      </div>
                    </div>

                    {/* Parties */}
                    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:20, marginBottom:24 }}>
                      <div style={{ background:'#f9f9f9', borderLeft:'3px solid #CC0000', padding:'12px 16px' }}>
                        <div style={{ fontSize:10, fontWeight:800, color:'#CC0000', letterSpacing:'0.1em', textTransform:'uppercase', marginBottom:8 }}>Quoted To</div>
                        <div style={{ fontSize:15, fontWeight:700 }}>{customer.name}</div>
                        {customer.company && <div style={{ fontSize:12, color:'#555', marginTop:2 }}>{customer.company}</div>}
                        {customer.phone   && <div style={{ fontSize:12, color:'#555' }}>📞 {customer.phone}</div>}
                        {customer.email   && <div style={{ fontSize:12, color:'#555' }}>✉️ {customer.email}</div>}
                        {customer.address && <div style={{ fontSize:12, color:'#555' }}>📍 {customer.address}</div>}
                      </div>
                      <div style={{ background:'#fff8f8', borderLeft:'3px solid #CC0000', padding:'12px 16px' }}>
                        <div style={{ fontSize:10, fontWeight:800, color:'#CC0000', letterSpacing:'0.1em', textTransform:'uppercase', marginBottom:8 }}>Quoted By</div>
                        <div style={{ fontSize:15, fontWeight:700 }}>Techdave Solutions</div>
                        <div style={{ fontSize:12, color:'#555', marginTop:2, lineHeight:1.7 }}>
                          {TECHDAVE_INFO.address}<br/>
                          {TECHDAVE_INFO.phone1}<br/>
                          {TECHDAVE_INFO.email}
                        </div>
                      </div>
                    </div>

                    {/* Items table */}
                    <table style={{ width:'100%', borderCollapse:'collapse', marginBottom:16 }}>
                      <thead>
                        <tr>
                          {['#','Item Description','Qty','Unit Price (USD)','Total (USD)'].map((h,i) => (
                            <th key={h} style={{ background:'#CC0000', color:'#fff', padding:'10px 12px', textAlign: i>1?'right':i===2?'center':'left', fontSize:11, fontWeight:700, textTransform:'uppercase', letterSpacing:'0.04em' }}>{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {quoteItems.map((item, i) => (
                          <tr key={item.id} style={{ background: i%2===0?'#fff':'#fafafa' }}>
                            <td style={{ padding:'10px 12px', fontSize:12, color:'#555', borderBottom:'1px solid #e5e7eb' }}>{i+1}</td>
                            <td style={{ padding:'10px 12px', borderBottom:'1px solid #e5e7eb' }}>
                              <div style={{ fontWeight:600 }}>{item.name}</div>
                              {item.brand && <div style={{ fontSize:11, color:'#888', marginTop:2 }}>{item.brand} · {item.category}</div>}
                            </td>
                            <td style={{ padding:'10px 12px', textAlign:'center', fontWeight:600, borderBottom:'1px solid #e5e7eb' }}>{item.qty}</td>
                            <td style={{ padding:'10px 12px', textAlign:'right', borderBottom:'1px solid #e5e7eb' }}>{item.unitPrice.toFixed(2)}</td>
                            <td style={{ padding:'10px 12px', textAlign:'right', fontWeight:700, borderBottom:'1px solid #e5e7eb' }}>{(item.unitPrice*item.qty).toFixed(2)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>

                    {/* Totals */}
                    <div style={{ marginLeft:'auto', width:260, marginBottom:20 }}>
                      <div style={{ display:'flex', justifyContent:'space-between', padding:'6px 0', fontSize:13, borderBottom:'1px solid #f0f0f0' }}>
                        <span>Subtotal</span><span>USD {subtotal.toFixed(2)}</span>
                      </div>
                      <div style={{ display:'flex', justifyContent:'space-between', padding:'6px 0', fontSize:13, borderBottom:'1px solid #f0f0f0' }}>
                        <span>Tax / VAT</span><span>USD 0.00</span>
                      </div>
                      <div style={{ display:'flex', justifyContent:'space-between', padding:'10px 0 6px', fontSize:17, fontWeight:900, color:'#CC0000', borderTop:'2px solid #CC0000', marginTop:4 }}>
                        <span>TOTAL</span><span>USD {total.toFixed(2)}</span>
                      </div>
                    </div>

                    {/* Validity notice */}
                    <div style={{ background:'#fff8f8', border:'1px solid rgba(204,0,0,0.2)', borderRadius:6, padding:'10px 14px', marginBottom:16, fontSize:12, color:'#555' }}>
                      ⏳ This quotation is valid for <strong style={{ color:'#CC0000' }}>{validDays} days</strong> from the date of issue and expires on <strong style={{ color:'#CC0000' }}>{expiry}</strong>.
                      Prices are subject to availability.
                    </div>

                    {/* Notes */}
                    {notes && (
                      <div style={{ background:'#f9f9f9', borderRadius:6, padding:'10px 14px', marginBottom:20, fontSize:12, color:'#555', lineHeight:1.7 }}>
                        <div style={{ fontWeight:700, color:'#111', marginBottom:4 }}>Notes & Terms:</div>
                        {notes}
                      </div>
                    )}

                    {/* Signature lines */}
                    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:40, margin:'28px 0 20px' }}>
                      {['Authorised by (Techdave Solutions)','Accepted by (Customer)'].map(label => (
                        <div key={label}>
                          <div style={{ borderTop:'1px solid #333', paddingTop:6, fontSize:11, color:'#555' }}>{label}</div>
                          <div style={{ fontSize:11, color:'#aaa', marginTop:4 }}>Signature & Date</div>
                        </div>
                      ))}
                    </div>

                    {/* Footer */}
                    <div style={{ borderTop:'2px solid #CC0000', paddingTop:14, display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                      <div style={{ fontSize:13, fontWeight:700, color:'#CC0000' }}>Thank you for choosing Techdave Solutions!</div>
                      <div style={{ fontSize:11, color:'#555', textAlign:'right', lineHeight:1.7 }}>
                        {TECHDAVE_INFO.phone1} | {TECHDAVE_INFO.phone2}<br/>
                        {TECHDAVE_INFO.email} | {TECHDAVE_INFO.website}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default QuotationModal;
